import React from 'react';
import customizeDialog from '@alife/bc-customize-dialog';
import safeLog from '@alife/bc-safe-log';

export default class Customize extends React.PureComponent {
  state = {
    url: '',
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const {
      productId,
      companyId,
      productEncryptId,
      lightCustomModel,
      customModel,
    } = this.props;
    const orginUrl = '//customize.alibaba.com';
    fetch(
      `${orginUrl}/view/openApi/getGroupInfo?customizationTemplateId=${lightCustomModel}&customModelId=${customModel}&companyId=${companyId}`,
    )
      .then(rst => rst.json())
      .then(rst => {
        const { data } = rst;
        if (!data || !data.editUri) return;
        this.setState({
          url: `${data.editUri}&productId=${productId}&productIdf=${productEncryptId}`,
        });
      });
  }

  render() {
    const { url } = this.state;
    const { lightCustomModel, customModel } = this.props;
    return (
      (!lightCustomModel || !customModel) && (
        <div className="3d-customization-item">
          <img
            src="//img.alicdn.com/tfs/TB1KmNrsEH1gK0jSZSyXXXtlpXa-16-16.svg"
            alt="3d-icon"
            width="18"
          />
          Alibaba.com build-in online customization &nbsp;
          <a
            href={url}
            className="customise-entry"
            onClick={e => {
              e.preventDefault();
              customizeDialog.show(url);
              safeLog(
                '/sc.details.customizeOpen',
                'CLk',
                `from=mainAction&groupId=453&customizationTemplateId=`,
                'GET',
              );
              safeLog(
                '/sc.details.customizeExpose',
                'EXP',
                `groupId=453&customizationTemplateId=`,
                'GET',
              );
            }}
          >
            Customise Now
          </a>
        </div>
      )
    );
  }
}
